var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8CylindersChained50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20,15v-3c0-1.105-0.895-2-2-2l0,0c-1.105,0-2,0.895-2,2v3H20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32,15v-3c0-1.105-0.895-2-2-2l0,0c-1.105,0-2,0.895-2,2v3H32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.99,28c0-0.55,0.45-1,1-1l0,0c0.55,0,1,0.45,1,1l0,0c0,0.55-0.45,1-1,1l0,0 C23.44,29,22.99,28.55,22.99,28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.5,17h-3c-1.381,0-2.5,1.119-2.5,2.5V38h8V19.5C34,18.119,32.881,17,31.5,17z M28.27,28.79 c-0.04,0.01-0.07,0.01-0.1,0.01c-0.51,0-0.95-0.39-1-0.9c-0.05-0.55,0.35-1.04,0.9-1.1c0.55-0.05,1.04,0.35,1.09,0.9 C29.22,28.25,28.82,28.729,28.27,28.79z M32.51,28.109c-0.07,0.021-0.14,0.03-0.21,0.03c-0.46,0-0.88-0.32-0.98-0.78 c-0.12-0.54,0.21-1.079,0.75-1.199s1.08,0.22,1.2,0.76C33.39,27.46,33.05,27.99,32.51,28.109z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.5,17h-3c-1.381,0-2.5,1.119-2.5,2.5V38h8V19.5C22,18.119,20.881,17,19.5,17z M16.67,27.35 c-0.11,0.47-0.52,0.79-0.98,0.79c-0.07,0-0.14-0.01-0.21-0.03c-0.54-0.119-0.88-0.659-0.76-1.189c0.12-0.54,0.65-0.88,1.19-0.76 C16.45,26.281,16.79,26.819,16.67,27.35z M19.82,28.8c-0.03,0-0.07-0.01-0.1-0.01c-0.55-0.061-0.95-0.55-0.89-1.101 c0.05-0.54,0.54-0.939,1.09-0.89c0.55,0.05,0.95,0.55,0.9,1.1C20.76,28.41,20.33,28.8,19.82,28.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.36,26.3c-0.2-0.52,0.05-1.1,0.57-1.3l0,0c0.51-0.2,1.09,0.06,1.29,0.569l0,0 c0.2,0.521-0.05,1.101-0.57,1.301h0.01c-0.12,0.04-0.25,0.069-0.37,0.069l0,0C35.89,26.939,35.51,26.689,35.36,26.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.33,26.859c-0.51-0.199-0.77-0.779-0.57-1.29l0,0c0.2-0.52,0.78-0.77,1.3-0.569l0,0 c0.51,0.2,0.77,0.78,0.57,1.29l0,0c-0.16,0.399-0.54,0.64-0.94,0.64l0,0C11.57,26.93,11.45,26.91,11.33,26.859z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 24,
    r: 1,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 24,
    r: 1,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CylindersChained50);
export default __webpack_public_path__ + "static/media/icons8-cylinders-chained-50.4730eda399a4ec0b3099e720acfbc2cc.svg";
export { ForwardRef as ReactComponent };